import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tagFilter',
    pure: true
})

export class TagFilterPipe implements PipeTransform {
    transform(items: any[], filter: number): any[] {
        if (!items || !filter) {
            return items;
        }
        return items.filter(item => item.tags.includes(+filter));
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/pipes/tag-filter.pipe.ts